import type { PaletteOptions } from '@mui/material/styles';
import {
  ADMIN_BACKGROUND_LIGHT,
  ADMIN_PRIMARY,
  ADMIN_SECONDARY,
  BACKGROUND_DARK,
  BRAND,
  PORTAL_BACKGROUND_LIGHT,
  PORTAL_SECONDARY,
} from './tokens';

// What legitimately differs between the two surfaces. Anything not listed here
// (brand, required, error, typography, component defaults) is shared and lives
// in createAppTheme. Values come from tokens.ts — no literals here.

type SchemePalette = Pick<PaletteOptions, 'primary' | 'secondary' | 'background'>;

export interface ThemePreset {
  light: SchemePalette;
  dark: SchemePalette;
}

/** Admin app: neutral grey chrome. */
export const ADMIN_PRESET: ThemePreset = {
  light: {
    primary: ADMIN_PRIMARY.light,
    secondary: ADMIN_SECONDARY.light,
    background: ADMIN_BACKGROUND_LIGHT,
  },
  dark: {
    primary: ADMIN_PRIMARY.dark,
    secondary: ADMIN_SECONDARY.dark,
    background: BACKGROUND_DARK,
  },
};

/**
 * Customer portal: teal is the primary. Used as an accent on neutral chrome
 * (header/footer), not as a full-width brand bar.
 */
export const PORTAL_PRESET: ThemePreset = {
  light: {
    primary: BRAND.light,
    secondary: PORTAL_SECONDARY.light,
    background: PORTAL_BACKGROUND_LIGHT,
  },
  dark: {
    primary: BRAND.dark,
    secondary: PORTAL_SECONDARY.dark,
    background: BACKGROUND_DARK,
  },
};
